import { useRef } from "react"
import BollinoVerdeForm from "./BollinoVerdeForm";
import { Loading } from "../../common/components/loading";
import { BollinoDto, ImpiantoDto, PeriodDto } from "../../generated";
import { AccordionItem } from "../../common/accordion";
import OpenModalButton from "../../common/components/openModalButton";
import BolliniVerdiActions from "../BolliniVerdiActions";
import { Divider } from "../../common/components/CmForms";
import BolliniVerdiHelper from "../BolliniVerdiHelper";
import BolliniVerdiStore from "../BolliniVerdiStore";
import { messageAlert } from "../../common/components/confirm";
import DatesHelper from "../../common/datesHelper";
import Period from "../../common/period";
import React from "react";


export const BolliniVerdiAccordion = (props: { impianto: ImpiantoDto, isNew: boolean }) => {
    const bolliniVerdi = BolliniVerdiStore.useForImpianto(props.impianto.idImpianto);

    const modal = useRef<OpenModalButton>(null);
    if (!bolliniVerdi)
        return <Loading />;

    const bollinoValid = BolliniVerdiHelper.getValid(bolliniVerdi);
    return <AccordionItem className="my-4"
        open={bollinoValid != null}
        heading={isOpen =>
            <div>
                <Divider
                    caption={
                        <span>
                            <span className="badge rounded-pills bg-info me-2">{bolliniVerdi.length}</span>
                            {bolliniVerdi.length === 1 ? "Bollino" : "Bollini"}
                            {bolliniVerdi.length > 0 && <i className={`${isOpen ? "fas fa-chevron-up" : "fas fa-chevron-down"} ms-3`} />}
                        </span>
                    }
                    color={bollinoValid ? "theme" : "warning"}
                    additionalItems={
                        <>
                            <div className="me-3">{bollinoValid ? <div className="text-info"><i className="fas fa-check me-2" />Bollino valido ({DatesHelper.getReadableCompactDateString(bollinoValid.validity.from)}-{DatesHelper.getReadableCompactDateString(bollinoValid.validity.to)})</div> : bolliniVerdi.length > 0 ? <div className="text-warning"><i className="fas fa-times" />  Bollino scaduto</div> : undefined}</div>
                            {props.isNew ?
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => messageAlert("Attenzione per poter inserire un nuovo bollino è prima necessario salvare l'impianto")}>
                                    <i className="fas fa-plus" /> Aggiungi bollino
                                </button>
                                :
                                <OpenModalButton
                                    ref={modal}
                                    className="btn btn-outline-secondary"
                                    modalContent={
                                        <BollinoVerdeForm
                                            bollinoVerde={new BollinoDto({
                                                idImpianto: props.impianto.idImpianto,
                                                idBollino: 0,
                                                validity: { from: DatesHelper.Today(), to: DatesHelper.AddMonths(DatesHelper.Today(), 48) } as PeriodDto
                                            })}
                                            onCancel={() => modal.current!.close()}
                                            onSubmit={
                                                async b => {
                                                    const exist = bolliniVerdi.find(x =>
                                                        Period.Create(x.validity.from, x.validity.to)
                                                            .containsPeriod(Period.Create(b.validity.from, b.validity.to))
                                                    )
                                                    if (exist) {
                                                        alert(`Non è possibile salvare il bollino. Per questo impianto esiste già un bollino che ha una validità che copre ${DatesHelper.getReadableCompactDateString(exist.validity.from)} -> ${DatesHelper.getReadableCompactDateString(exist.validity.to)}`)
                                                    } else {
                                                        await BolliniVerdiActions.add(b);
                                                        modal.current?.close();
                                                    }
                                                }
                                            }
                                        />
                                    }
                                >
                                    <i className="fas fa-plus" /> Aggiungi bollino
                                </OpenModalButton>
                            }
                        </>
                    }
                />
            </div>
        }>
        <BolliniVerdiList
            bolliniVerdi={bolliniVerdi}
            onDelete={bollino => BolliniVerdiActions.delete(bollino.idImpianto, bollino.idBollino)}
        />
    </AccordionItem>
}


export const BollinoVerdeListItem = (props: { bollino: BollinoDto, onDelete: () => void; }) => {
    const { bollino, onDelete } = props;
    const modal = useRef<OpenModalButton>(null);
    const isExpired = BolliniVerdiHelper.isExpired(bollino);
    return <div className="card shadow-sm me-4" >
        <div className="card-body">
            <div>
                <strong className="me-1">{isExpired ? "Scaduto" : "Valido"}</strong>
                <span className={!isExpired ? "badge bg-success" : "fw-bold text-danger"}
                    style={{ textDecoration: isExpired ? "line-through" : undefined, fontWeight: isExpired ? undefined : "bold", fontSize: "1rem" }}>
                    {`${DatesHelper.getReadableCompactDateString(bollino.validity.from)}-${DatesHelper.getReadableCompactDateString(bollino.validity.to)}`}
                </span>
            </div>
            <div>
                <strong className="me-1">Codice:</strong>{bollino.codiceBollino}
            </div>
        </div>
        <div className="card-footer">
            <OpenModalButton
                ref={modal}
                className="btn btn-outline-secondary ms-auto"
                modalContent={<BollinoVerdeForm
                    bollinoVerde={bollino}
                    onCancel={() => modal.current!.close()}
                    onSubmit={
                        async bollinoVerde => {
                            await BolliniVerdiActions.update(bollino.idBollino, bollinoVerde);
                            modal.current?.close();
                        }
                    }
                />}
            >
                <i className="fas fa-edit" /> <span className="hidden-sm-down">Modifica</span>
            </OpenModalButton>
            <button type="button" className="btn btn-danger ms-1" onClick={onDelete}>
                <i className="fas fa-trash" />
            </button>
        </div>
    </div>
}
export const BolliniVerdiList = (props: { bolliniVerdi: BollinoDto[], onDelete: (bollino: BollinoDto) => void }) => {
    return <div className="d-flex flex-grow">
        {
            props.bolliniVerdi.map((bollino) => <BollinoVerdeListItem
                key={bollino.idBollino}
                bollino={bollino}
                onDelete={() => props.onDelete(bollino)}
            />)
        }
    </div>
}